module.exports = __webpack_public_path__ + "static/css-38f3ba2f4bddb4cfbb516987973032c0.png";